// extracted by mini-css-extract-plugin
module.exports = {"reasons-list":"ReasonsList_reasons-list__1WVuY"};